/*******************************************************************************
 * Copyright (c) 2019 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *******************************************************************************/

import React from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

import Button from '@mui/material/Button'
import CardActions from '@mui/material/CardActions'
import { useTranslation } from 'react-i18next';

import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import PageSubHeader from '../Layout/PageSubHeader'
import ContactUsSection from '../shared/ContactUsSection'
import Testimonies from "../shared/Testimonies"



const Enterprise = ( ) => {

  const { classes } = useStyles();
  const { t } = useTranslation()
  return (
    <React.Fragment>
      <PageSubHeader location={t('titles:entreprise')} />
      <Grid container spacing={4} className={classes.pageContainer}>
        <Grid item xs={12} sm={12} md={12}>
          <div style={{ marginBottom: '10px' }}>

            <Grid container justify="center" className={classes.pageContainer} spacing={4} >
              <Grid item xs={12} sm={12} md={12}>
                <Typography className={classes.titleBase} variant="h3" align="center" color="textPrimary" gutterBottom>
                {t('titles:enterprise')}

                </Typography>
                <div className={classes.sectionTitleBorder}></div>

                <Typography className={classes.titleBaseDescp} align="center" gutterBottom>
                {t('descp:digitalAssetDescp')}

                </Typography>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>

          <Grid container justify="center" className={classes.pageContainer} spacing={4} >
            <Grid item xs={12} sm={6} md={4}>

              <Card className={classes.cardService} >
                <CardContent className={classes.cardContentService} >
                  <img src="assets/images/icons/coding.png" width="40" className='alignCenter' style={{ marginBottom: '10px' }} alt="coding" />

                  <Typography className={classes.titleBase} variant="h3" align="center" color="textPrimary" gutterBottom>
                    {t('titles:rapiddevelopment')}
                  </Typography>
                  <div className={classes.sectionTitleBorder}></div>

                  <Typography variant="h4" align="center" color="textPrimary" gutterBottom>
                    
                    {t('titles:Prototyping')}

                  </Typography>
                  <Typography variant="h4" align="center" color="textPrimary" gutterBottom>
                  {t('titles:Templates')}  
                  </Typography>
                  <Typography variant="h4" align="center" color="textPrimary" gutterBottom>
                  {t('titles:CodeLibrary')} 
                    

                  </Typography>
                </CardContent>
                <CardActions>
                  <Button variant="outlined" fullWidth color="primary" href="mailto:info@belltane.com"  >
                  {t('titles:moreDetails')}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>

              <Card className={classes.cardService}>
                <CardContent className={classes.cardContentService}>
                  <img src="assets/images/icons/innovation.png" width="40" className='alignCenter' style={{ marginBottom: '10px' }} alt="coding" />

                  <Typography className={classes.titleBase} variant="h3" align="center" color="textPrimary" gutterBottom>
                    {t('titles:modern')}
                  </Typography>
                  <div className={classes.sectionTitleBorder}></div>

             
                  <Typography variant="h4" align="center" color="textPrimary" gutterBottom>
                    React / PWAs


                  </Typography>
                  <Typography variant="h4" align="center" color="textPrimary" gutterBottom>
                  {t('titles:MicroServices')}
 
                  </Typography>
                  <Typography variant="h4" align="center" color="textPrimary" gutterBottom>

                    Web3

                  </Typography>
                </CardContent>
                <CardActions>
                  <Button variant="outlined" fullWidth color="primary" href="mailto:info@belltane.com" >
                  {t('titles:moreDetails')}

                  </Button>
                </CardActions>
              </Card>

            </Grid>
            <Grid item xs={12} sm={6} md={4}>

              <Card className={classes.cardService}>
                <CardContent className={classes.cardContentService} >
                  <img src="assets/images/icons/dashboard.png" width="40" className='alignCenter' style={{ marginBottom: '10px' }} alt="coding" />

                  <Typography className={classes.titleBase} variant="h3" align="center" color="textPrimary" gutterBottom>
                    {t('titles:datadriven')}
                  </Typography>
                  <div className={classes.sectionTitleBorder}></div>

               
              
                  <Typography variant="h4" align="center" color="textPrimary" gutterBottom>
                  {t('titles:Transactions')}  
                  </Typography>
                  <Typography variant="h4" align="center" color="textPrimary" gutterBottom>
                   {t('titles:Aggregations')} 
                  </Typography>
                  <Typography variant="h4" align="center" color="textPrimary" gutterBottom>
                  {t('titles:Analytics')}   
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button variant="outlined" fullWidth color="primary" href="mailto:info@belltane.com" >
                  {t('titles:moreDetails')}

                  </Button>
                </CardActions>
              </Card>

            </Grid>



          </Grid>
        </Grid>

      </Grid>


      <Grid item xs={12} sm={12} md={12}>

        <ContactUsSection />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.cotainerListIfo}>

        <Testimonies />
      </Grid>

    </React.Fragment>
  );
}

const useStyles = makeStyles({ "name": { Enterprise } })((theme) => ({

  cardService: {
    position: 'relative',
    display: 'block',
    padding: '1px 30px',
    transition: 'all .25s cubic- bezier(.645, .045, .355, 1)',
    borderRadius: '5px',
    zIndex: '99',
    backgroundColor: '#fff!important',
    maxHeight: '500px',
    minHeight: '350px',

    "&:hover": {
      transform: 'scale(1.05)',
      boxShadow: " 0 2.8px 2.2px rgba(0, 0, 0, 0.034),0 6.7px 5.3px rgba(0, 0, 0, 0.048),0 12.5px 10px rgba(0, 0, 0, 0.06), 0 22.3px 17.9px rgba(0, 0, 0, 0.072),0 41.8px 33.4px rgba(0, 0, 0, 0.086),0 100px 80px rgba(0, 0, 0, 0.12)",

    }

  },
  cardContentService: {
    maxHeight: '250px',
    minHeight: '250px',
  },
  pageContainer: {
    backgroundColor: '#dce7eb',
    padding: '1.5%',

  },

  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  cardContent: {
    flexGrow: 1,
  },

  titleBase:
  {
    fontWeight: 'bold',
    fontSize: '1.5rem',
    color: 'white',
    textTransform: 'uppercase'
  },
  gridBoxbtn: {
    border: '1px solid #fb743e',
    backgroundColor: 'white',
    color: '#383e56',
    "&:hover": {
      background: '#9fb8ad',
      color: 'white',


    },

  },

  sectionTitleBorder: {
    width: '100px',
    height: '2px',
    marginRight: 'auto',
    marginLeft: 'auto',
    backgroundColor: '#fb743e',
    marginBottom: '30px',

  },
  titleBaseDescp: {
    fontSize: '20px!important',
    fontWeight: 400,
    fontStyle: 'normal',
    lineHeight: 1.74,
    position: 'relative',
    visibility: 'visible',
    color: '#748494'
  },
  cotainerListIfo: {
    backgroundColor: '#f8faff',
    padding: '10px'
  },
  title: {
    fontSize: '16px!important',
    fontWeight: '500!important',
    color: "#8b8b8b!important"
  }
}));

export default Enterprise;